import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, IconButton, Paper, Typography, TextField, InputAdornment } from "@mui/material";
import { ReactComponent as Send } from "../assets/submit.svg";
import { ReactComponent as MicIcon } from "../assets/Group 18331 (1).svg";
import { ReactComponent as MicOnIcon } from "../assets/Group.svg";

import { ReactComponent as SiriIcon } from "../assets/Siri AnimationIcon.svg";
import { ReactComponent as CloseIcon } from "../assets/close.svg";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import PatientListDialog from "../popup/PatientListDialog";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserLocalData } from "../lib/helper";
import GoogleTextToSpeech from "../common/GoogleTextToSpeech";
import DashboardLayout from "./DashboardLayout";
import PatientInfo from "./PatientInfo";

const VoiceSearch2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const chatsMessages = location?.state?.chatsMessages || [];
  const [query, setQuery] = useState("");
  const [messages, setMessages] = useState(chatsMessages);
  const [loading, setLoading] = useState(false);
  const { user_name } = getUserLocalData();
  const { token, patient_id, session_id } = getUserLocalData();
  const { transcript, finalTranscript, listening, resetTranscript } =
    useSpeechRecognition({});
  const validPatientId =
    patient_id && patient_id !== "undefined" ? patient_id : null;
  const validSessionId =
    session_id && session_id !== "undefined" ? session_id : null;
  const [patientList, setPatientList] = useState([]);
  const [isLoadingScreen, setIsLoadingScreen] = useState(true);
  const [open, setOpen] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [messageHistory, setSaveMessageHistory] = useState([]);
  const [activeState, setActiveState] = useState("");
  useEffect(() => {
    setActiveState(location?.state);
  }, [location?.state]);

  useEffect(() => {
    if (!listening && transcript.trim()) {
      sendMessage(new Event("submit"));
    }
  }, [listening]);

  useEffect(() => {
    setIsLoadingScreen(false);
    // Auto-start listening when component mounts
    const startListening = async () => {
      try {
        if (SpeechRecognition.browserSupportsSpeechRecognition()) {
          await SpeechRecognition.startListening({ continuous: false });
          console.log("Auto-started speech recognition");
        } else {
          console.error("Browser doesn't support speech recognition");
        }
      } catch (error) {
        console.error("Error starting speech recognition:", error);
      }
    };

    // Small delay to ensure component is fully mounted
    const timer = setTimeout(() => {
      startListening();
    }, 800);

    return () => {
      clearTimeout(timer);
      SpeechRecognition.abortListening();
      SpeechRecognition.stopListening();
      resetTranscript();
    };
  }, []);

  const sendMessage = async (e) => {
    if (!transcript.trim()) return; // Prevent empty submissions

    const userInput = transcript.trim();
    resetTranscript(); // Reset voice input
    try {
      if (!validPatientId) {
        // This is for patient list purposes
        const response = await axios.post(
          `${process.env.REACT_APP_QUERY_URL}?query=${userInput}&access_token=${token}&identity=CLARA`
        );

        if (response?.data) {
          // setPatientList(response?.data?.patients);
          setPatientList(response?.data?.patient);
          setOpen(true);
          console.log(response?.data?.patient, 'list');
          setResponseMessage(response?.data?.response);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onChatClick = () => {
    navigate("/chat", {
      state: { messageHistory, conversationId: validSessionId },
    });
  };

  const onCancelClick = () => {
    if (validPatientId) {
      // navigate(-1);
    } else {
      onChatClick();
    }
  };

  const saveConversation = (messages) => {
    setSaveMessageHistory([...messageHistory, ...messages]);
  };

  return (
    <>

      <DashboardLayout >
        <Box display={'flex'} justifyContent={'flex-start'} flexDirection={'row'} sx={{ width: '100%', height: '100%', }}>
          <Box sx={{ mt: 2 }}> <PatientInfo /></Box>
          <Box sx={{ width: '100%', height: '100vh', }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 'calc(100vh - 190px)',
                textAlign: 'center',
              }}
            >
              <Box sx={{ marginTop: '-100px', mb: 4 }}>
                <Typography variant="h6" color="white" sx={{ mb: 1 }}>
                  Speaking to <strong>CLARA</strong>
                </Typography>
                {listening ? (
                  <>
                    <Typography variant="body1" color="#00D173" sx={{ mb: 2 }}>
                      Go ahead, I am attentive and listening
                    </Typography>
                    {transcript && (
                      <Typography variant="body2" color="#fff" sx={{ fontStyle: 'italic' }}>
                        "{transcript}"
                      </Typography>
                    )}
                  </>
                ) : (
                  <Typography variant="body1" color="#b0b0b0">
                    Ask me about this patient
                  </Typography>
                )}
              </Box>
              <Box>
                <SiriIcon width={120} height={120} />
              </Box>
              <Box>
                {!isLoadingScreen ? (
                  <GoogleTextToSpeech
                    transcript={transcript}
                    listening={listening}
                    saveConversation={saveConversation}
                    resetTranscript={resetTranscript}
                    isPopUpOpen={open}
                  />
                ) : null}
              </Box >

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  justifyContent: 'center',
                  position: 'fixed',
                  bottom: '1rem',
                }}
              >
                <Box sx={{ cursor: 'pointer' }}>
                  <MicIcon width={64} height={64} onClick={() =>
                    SpeechRecognition.startListening({ continuous: false })
                  } />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        {open && (
          <Box sx={{
            position: 'absolute',
            left: '200px',
            borderRadius: '14px',
            border: '1px solid rgba(234, 236, 240, 0.06)'
          }}>
            <PatientListDialog
              open={open}
              setOpen={setOpen}
              data={patientList}
              message={responseMessage}
            />
          </Box>
        )}
      </DashboardLayout>
    </>
  );
};

export default VoiceSearch2;
